import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { Component, useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { Avatar, Divider, Grid, IconButton, InputAdornment, Stack, TextField } from '@mui/material';
// import SendIcon from "@mui/icons-material/Send";
// import {
//   useAttachmentListQuery,
//   useDiscussionListQuery,
//   useSaveDiscussionMutation,
//   useSaveDiscussionReplyMutation
// } from "@tms/services/tms-discussion";
import CommentReply from './CommentSections/CommentReply';
import CommentHeader from './CommentSections/CommentHeader';
// import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import { getValue } from '@testing-library/user-event/dist/utils';
import CommentFooter from './CommentSections/CommentFooter';
import AttachmentList from './CommentSections/AttachmentList';
import { useParams } from 'react-router-dom';
import {
  useAttachmentListQuery,
  useDiscussionListQuery,
  useSaveDiscussionMutation
} from 'redux/reducers/user/dashboard/tms-discussion';
import { toast } from 'react-toastify';
import { MdPieChartOutline } from 'react-icons/md';
import { BiSend } from 'react-icons/bi';
// import { toastInfo } from "@tms/components/Toast";

const Discussion = ({
  sessionId,
  courseTitle,
  activeModule,
  detail
}: {
  sessionId: string;
  courseTitle: string;
  activeModule: string;
  detail: any;
}) => {
  const defaultValuesComment = {
    id: null as number | null,
    content: ''
  };
  const { handleSubmit, reset, setValue, watch, getValues } = useForm({
    defaultValues: defaultValuesComment
  });

  const { training_id: routineId } = useParams();

  const { data: discussionList, isLoading } = useDiscussionListQuery(
    sessionId ?? '',
    courseTitle ?? '',
    routineId ?? ''
  );

  const { data: attachmentList, isLoading: isAttachmentLoading } = useAttachmentListQuery(
    sessionId ?? '',
    routineId ?? ''
  );

  const [showReply, setShowReply] = useState<{ [x: string]: boolean }>();

  const { mutateAsync: addDiscussion, isLoading: isSaving } = useSaveDiscussionMutation();

  function onSubmitData(discussionDetails: typeof defaultValuesComment) {
    const requestBody = {
      content: discussionDetails.content,
      routine: routineId
    };
    if (!requestBody.content) {
      toast.info('Comment cannot be blank!');
    } else {
      addDiscussion({
        sessionId: sessionId,
        courseTitle: courseTitle,
        discussionDetail: requestBody
      }).then((_) => reset());
    }
  }
  useEffect(() => {
    if (discussionList && discussionList?.length > 0) {
      setShowReply(
        (discussionList && (discussionList as [{ id: any }])).reduce((ac: any, c: any) => {
          return {
            ...ac,
            [c.id]: false
          };
        }, {})
      );
    }
  }, [discussionList]);
  const commentValue = watch('content');

  return (
    <>
      <Typography fontSize={20} fontWeight={600} color={'primary'}>
        {' '}
        Discussion
      </Typography>

      <Box>
        <Grid
          container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: '15px'
          }}>
          <Grid
            item
            xs={12}
            style={{
              height: '520px',
              overflowY: 'scroll',
              overflowX: 'hidden'
            }}>
            {discussionList &&
              discussionList?.length > 0 &&
              discussionList?.map((data: any, index: number) => {
                const key = data.id;
                return (
                  <Box marginY={3} key={index}>
                    <Stack
                      direction="column"
                      p={1}
                      sx={{
                        backgroundColor: 'white'
                      }}>
                      <CommentHeader data={data} />
                      <>
                        <Divider />
                        <Box m={2}>
                          <Stack
                            direction="row"
                            justifyContent="flex-start"
                            p={1}
                            sx={{
                              backgroundColor: 'white',
                              height: 1
                            }}
                            spacing={1}>
                            <MdPieChartOutline />
                            <Typography
                              sx={{
                                fontSize: '12px',
                                marginLeft: '5px',
                                cursor: 'pointer'
                              }}
                              onClick={() =>
                                setShowReply((prev) => ({
                                  ...prev,
                                  [data.id]: !prev?.[data.id]
                                }))
                              }>
                              {data?.replies?.length > 0
                                ? 'View ' + data?.replies?.length + ' replies'
                                : '0 replies.Click here to add reply.'}
                            </Typography>
                          </Stack>
                        </Box>
                      </>
                      {showReply && showReply[key] && (
                        <Box>
                          {data.replies?.map((reply: any, replyIndex: number) => {
                            return <CommentReply reply={reply} key={replyIndex} />;
                          })}
                          <Divider />
                          <CommentFooter
                            data={data}
                            sessionId={sessionId}
                            courseTitle={courseTitle}
                          />
                        </Box>
                      )}
                    </Stack>
                  </Box>
                );
              })}
          </Grid>
          {/* <Grid
            item
            xs={3}
            sx={{
              paddingLeft: '20px',
              height: '520px',
              overflowY: 'scroll',
              overflowX: 'hidden'
            }}>
            <AttachmentList attachmentList={detail} isAttachmentLoading={isAttachmentLoading} />
          </Grid> */}
        </Grid>

      </Box>
    </>
  );
};

export default Discussion;
